import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

interface HeadingProps {
  title: string;
  description?: string;
  button?: boolean;
}

const Heading = ({ title, description, button }: HeadingProps) => {
  return (
    <React.Fragment>
      <Row className="align-items-center mb-3 px-3">
        <Col>
          <h4 className="mb-0 text-black">{title}</h4>
          {description && <p className="text-muted mb-0 fs-5">{description}</p>}
        </Col>
        {button && (
          <Col className="text-end">
            <Link to="#" className="btn btn-primary">
              Action Button
            </Link>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default Heading;
